module.exports = __webpack_public_path__ + "img/logo-unshaded.1cef5742.png";